import React from "react";
import moment from "moment";
import { DatePicker } from "antd";
import { Label } from "../globals";

const { RangePicker } = DatePicker;

function RangePickerComp({
  onCalendarChange,
  renderExtraFooter,
  format,
  showTime,
  disabledHours,
  hideDisabledOption,
  placeholder,
  value,
  onChange,
  style,
  disabledDate,
  label,
  required,
  warning,
  ignoreDisabledDate,
  getPopupContainer,
}) {
  const disabledDate2 = (current) => current && current.isAfter(moment());

  moment.locale("en", {
    week: {
      dow: 1,
    },
  });

  return (
    <>
      {!!label && (
        <Label className="text-sm-label" required={required} error={warning}>
          {label}
        </Label>
      )}
      <RangePicker
        onCalendarChange={onCalendarChange}
        renderExtraFooter={renderExtraFooter}
        className={warning ? "error_border" : "order-input-form-group"}
        format={format}
        showTime={showTime}
        style={
          style || {
            width: "100%",
          }
        }
        disabledHours={disabledHours}
        hideDisabledOption={hideDisabledOption}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabledDate={
          ignoreDisabledDate ? undefined : disabledDate || disabledDate2
        }
        getPopupContainer={getPopupContainer}
      />
    </>
  );
}

export default RangePickerComp;
